// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34Psl","colBig":"styles_colBig__AUFEM","colSmall":"styles_colSmall__3bllg","shopifyNameWrapper":"styles_shopifyNameWrapper__1gxcj"};